import React, { useState } from 'react'

import './Footer.scss'
import {
  arrFooter,
  arrFooterRight,
  arrFooterWwc,
  arrSocial,
} from 'commons/constant'
import { Link, useLocation } from 'react-router-dom'
import images from 'assets/images'

function Footer() {
  const { pathname } = useLocation()
  const [txtSign, setTxtSign] = useState('')

  const isWwc = pathname === '/world-wide-chain' || pathname === '/viction-da'
  const arrFooterFinal = isWwc ? arrFooterWwc : arrFooter

  const onChangeText = (e) => {
    const { value } = e.target

    setTxtSign(value)
  }

  return (
    <div className={`footer-wrapper ${isWwc && 'footer-wrapper--wwc'}`}>
      <div className='curve-up-wrapper'>
        <img src={images.curveBlackUp} alt='' className='curve-up' />
      </div>

      <div className='footer-container'>
        <div className='footer-left'>
          {arrFooterFinal.map((item, i) => {
            return (
              <div className={`menus ${item.isHide && 'menus--hide'}`} key={i}>
                <div className='menu-title'>{item.title}</div>

                <div className='menu-list'>
                  {item.menus.map((itemChild, index) => {
                    return (
                      <div
                        className={`item-menu text-hover-white-2 ${
                          itemChild.isComing && 'item-menu--coming'
                        } ${itemChild.isHide && 'item-menu--hide'}`}
                        key={index}>
                        <Link
                          to={itemChild.link}
                          className={`item-menu__text text-hover ${
                            isWwc && 'text-hover-white'
                          }`}
                          target={itemChild.isBlank && '_blank'}>
                          {itemChild.name}
                        </Link>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>

        <span className='icon-web_logo logo'></span>

        {!isWwc && (
          <div className='footer-right'>
            {arrFooterRight.map((item, i) => {
              return (
                <div
                  className={`menus ${item.isHide && 'menus--hide'}`}
                  key={i}>
                  <div className='menu-title'>{item.title}</div>

                  <div className='menu-list'>
                    {item.menus.map((itemChild, index) => {
                      return (
                        <div
                          className={`item-menu text-hover-white-2 ${
                            itemChild.isComing && 'item-menu--coming'
                          } ${itemChild.isHide && 'item-menu--hide'}`}
                          key={index}>
                          <Link
                            to={itemChild.link}
                            className={`item-menu__text text-hover ${
                              isWwc && 'text-hover-white'
                            }`}
                            target={itemChild.isBlank && '_blank'}>
                            {itemChild.name}
                          </Link>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>

      {isWwc && (
        <div className='text-img'>
          <img src={images.victionText} alt='' className='viction-text' />
        </div>
      )}
    </div>
  )
}

export default Footer
